import axios from '../utils/axios';

export default function bulkOnboardJobseekers(adminId, data) {
    return (
        axios.post(`/admin/${adminId}/jobseeker-bulk-onboard`, data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    )
}
